// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3HsSK{display:block;max-width:430px;position:relative}.mq4_q .wtejs{background:#f5f9ff;border:none;border-radius:8px;font-size:12px;font-size:1.2rem;height:36px;height:3.6rem;line-height:1}html[dir=ltr] .mq4_q .wtejs{padding-right:5rem}html[dir=rtl] .mq4_q .wtejs{padding-left:5rem}.mq4_q .wtejs::-webkit-input-placeholder{color:#6f7ea2}.mq4_q .wtejs::-moz-placeholder{color:#6f7ea2}.mq4_q .wtejs:-ms-input-placeholder{color:#6f7ea2}.mq4_q .wtejs::-ms-input-placeholder{color:#6f7ea2}.mq4_q .wtejs::placeholder{color:#6f7ea2}._7w0nl{fill:#6f7ea2;height:14px;height:1.4rem;margin-top:-.7rem;position:absolute;top:50%;width:14px;width:1.4rem}html[dir=ltr] ._7w0nl{right:20px;right:2rem}html[dir=rtl] ._7w0nl{left:20px;left:2rem}", ""]);
// Exports
exports.locals = {
	"searchPatients": "_3HsSK",
	"searchPatients__formGroup--topBar": "mq4_q",
	"searchPatients__formGroup__input": "wtejs",
	"searchPatients__icon": "_7w0nl"
};
module.exports = exports;
